var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRemoveDarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE4B\\u200D\\u2642\\uFE0F-Punters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Punters_Notes",
    transform: "translate(-722.000000, -1092.000000)",
    fill: "#102534"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729.267461,1105.73716 C729.627528,1106.08761 730.200183,1106.08761 730.56025,1105.73716 L732.499989,1103.79248 L734.439728,1105.73716 C734.800937,1106.08304 735.371309,1106.08304 735.732517,1105.73716 C736.089161,1105.37867 736.089161,1104.79918 735.732517,1104.44184 L733.792778,1102.49715 L735.732517,1100.55247 C736.078861,1100.19284 736.074296,1099.62249 735.721087,1099.26861 C735.369037,1098.91472 734.798665,1098.91012 734.439739,1099.25715 L732.5,1101.20184 L730.560261,1099.25715 C730.201335,1098.91013 729.630963,1098.91471 729.278913,1099.26861 C728.925723,1099.62249 728.921128,1100.19284 729.267483,1100.55247 L731.207222,1102.49715 L729.267483,1104.44184 C728.910839,1104.79918 728.910839,1105.37867 729.267483,1105.73716 L729.267461,1105.73716 Z M732.5,1113 C738.29899,1113 743,1108.29899 743,1102.5 C743,1096.70101 738.29899,1092 732.5,1092 C726.70101,1092 722,1096.70101 722,1102.5 C722,1108.29899 726.70101,1113 732.5,1113 Z",
    id: "Oval-2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRemoveDarkCircle);
export default __webpack_public_path__ + "static/media/cross-remove-dark-circle.67182e18d14b0b4f3002c8848221a098.svg";
export { ForwardRef as ReactComponent };